// src/pages/sales-order/tabs/MiscTab.jsx
import React from "react";
import SectionGrid from "../component/SectionGrid";

export default function MiscTab({
    fields,
    formData,
    errors,
    onChange,
    readOnly,
    getInputTypeForField,
    getValueForField,
}) {
    return (
        <SectionGrid
            fields={fields}
            formData={formData}
            errors={errors}
            onChange={onChange}
            readOnly={readOnly}
            idPrefix="misc"
            getInputTypeForField={getInputTypeForField}
            getValueForField={getValueForField}
        />
    );
}
